<template>
    <section class="dp-layout psychology-teacher-page">
        <!-- 左侧学校树 -->
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <!-- 右侧心理老师列表 -->
        <section class="dp-right">
            <template v-if="hasSchoolSelected">
                <!-- 顶部筛选与操作栏 -->
                <div class="filter-bar">
                    <el-form :inline="true" size="small" class="filter-form">
                        <el-form-item label="校区">
                            <el-select v-model="filterForm.campusId" placeholder="全部（含全校配置）" clearable style="width: 180px;" @change="handleSearch">
                                <el-option v-for="item in realCampusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="教师姓名">
                            <el-input v-model="filterForm.name" placeholder="请输入姓名或工号" clearable @keyup.enter.native="handleSearch" style="width: 180px;" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                        </el-form-item>
                    </el-form>

                    <div class="action-btn-group">
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">
                            新增心理老师
                        </el-button>
                    </div>
                </div>

                <!-- 提示栏 -->
                <div class="tip-bar">
                    <i class="el-icon-info"></i>
                    <span>
                        被配置为心理老师的教职工账号，在手机端登录后将自动获得【心理咨询预约审核】与【咨询签到核验】等专属功能菜单。
                        「全部校区」表示负责本校所有校区；指定校区则仅在该校区登录时生效。
                    </span>
                </div>

                <!-- 数据表格 -->
                <div class="tbl-scroll-host">
                    <el-table :data="tableData" v-loading="loading" border style="width: 100%;" height="100%" class="compact-table">
                        <el-table-column type="index" label="序号" width="60" align="center" />
                        <el-table-column prop="TeacherName" label="姓名" min-width="120">
                            <template slot-scope="scope">
                                <span class="teacher-name">{{ scope.row.TeacherName || scope.row.Name || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="TeacherAccount" label="工号/账号" min-width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.TeacherAccount || scope.row.WorkNumber || scope.row.Account || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="TeacherPhone" label="手机号码" min-width="130">
                            <template slot-scope="scope">
                                <span>{{ scope.row.TeacherPhone || scope.row.Phone || scope.row.ContactPhone || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="CampusName" label="负责校区" min-width="130">
                            <template slot-scope="scope">
                                <el-tag size="small" :type="isAllCampus(scope.row.CampusId) ? 'success' : 'info'">
                                    {{ isAllCampus(scope.row.CampusId) ? '全部校区' : (scope.row.CampusName || '-') }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Remark" label="职责备注" min-width="160" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.Remark || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="启用状态" width="100" align="center">
                            <template slot-scope="scope">
                                <el-switch
                                    v-model="scope.row.Enabled"
                                    :active-value="true"
                                    :inactive-value="false"
                                    @change="handleToggleEnable(scope.row)"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column prop="CreateTime" label="配置时间" width="160" align="center" />
                        <el-table-column label="操作" width="150" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button size="mini" type="text" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑</el-button>
                                <el-button size="mini" type="text" style="color: #F56C6C;" icon="el-icon-delete" @click="handleDelete(scope.row)">移除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 分页 -->
                <el-col :span="24" class="toolbar">
                    <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handlePageChange"
                        style="float: right;"
                    />
                </el-col>
            </template>

            <div v-else class="no-department-tip">
                <div class="no-department-tip__inner">
                    <i class="el-icon-school"></i>
                    <p>请在左侧选择所属学校，查看与维护心理老师</p>
                </div>
            </div>
        </section>

            <!-- 新增心理老师弹窗 -->
            <el-dialog title="新增心理老师" :visible.sync="addDialogVisible" width="520px" :close-on-click-modal="false">
                <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="110px">
                    <el-form-item label="负责校区" prop="CampusId">
                        <el-select v-model="addForm.CampusId" placeholder="请选择负责校区" style="width: 100%;">
                            <el-option :value="0" label="全部校区" />
                            <el-option v-for="item in realCampusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                        </el-select>
                        <span class="sub-hint">选择「全部校区」表示负责本校所有校区；也可指定单个校区</span>
                    </el-form-item>
                    <el-form-item label="选择教师" prop="TeacherId">
                        <div class="ps-pick-summary">
                            <span v-if="addForm.TeacherId">
                                已选 <strong>{{ selectedTeacherLabel || ('教职工#' + addForm.TeacherId) }}</strong>
                            </span>
                            <span v-else class="muted-text">请选择一名教职工</span>
                            <el-button type="primary" size="mini" plain @click="openTeacherPicker">选择教职工</el-button>
                            <el-button
                                v-if="addForm.TeacherId"
                                type="text"
                                size="mini"
                                @click="clearSelectedTeacher"
                            >清空</el-button>
                        </div>
                        <span class="sub-hint">从通讯录选择，仅绑定一人</span>
                    </el-form-item>
                    <el-form-item label="职责备注">
                        <el-input v-model="addForm.Remark" type="textarea" :rows="3" placeholder="例如：专职心理咨询师、分管高二年级" maxlength="200" show-word-limit />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="submitting" @click="submitAddForm">确 定</el-button>
                </div>
            </el-dialog>

            <!-- 编辑心理老师弹窗 -->
            <el-dialog title="编辑心理老师配置" :visible.sync="editDialogVisible" width="520px" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="110px" ref="editForm">
                    <el-form-item label="教师姓名">
                        <span>{{ editForm.Name }}</span>
                    </el-form-item>
                    <el-form-item label="负责校区">
                        <el-select v-model="editForm.CampusId" placeholder="请选择负责校区" style="width: 100%;">
                            <el-option :value="0" label="全部校区" />
                            <el-option v-for="item in realCampusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否启用">
                        <el-switch v-model="editForm.Enabled" />
                    </el-form-item>
                    <el-form-item label="职责备注">
                        <el-input v-model="editForm.Remark" type="textarea" :rows="3" placeholder="请输入职责备注" maxlength="200" show-word-limit />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="submitting" @click="submitEditForm">确 定</el-button>
                </div>
            </el-dialog>

            <person-scope-picker-dialog
                :visible.sync="teacherPickerVisible"
                directory-scope="internal"
                :show-scope-tabs="false"
                :scope-department-id="schoolId"
                :value="addForm.TeacherId"
                :label="selectedTeacherLabel"
                @confirm="onTeacherPicked"
            />
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';
import {
    getCampusList,
    getPsychologyTeacherListPage,
    addPsychologyTeacher,
    updatePsychologyTeacher,
    togglePsychologyTeacherEnable,
    deletePsychologyTeacher
} from '../../api/modules/psychology';
import {
    resolveActiveSchoolId,
    normalizeDeptId,
    treeNodeDeptId,
    deptIdsEqual,
} from '../../utils/deptCascaderProps';

export default {
    name: 'PsychologyTeacher',
    components: { DepartmentPane, PersonScopePickerDialog },
    data() {
        return {
            schoolId: '',
            schoolName: '',
            campusOptions: [],
            filterForm: {
                campusId: null,
                name: ''
            },
            tableData: [],
            page: 1,
            pageSize: 10,
            total: 0,
            loading: false,

            // 新增弹窗
            addDialogVisible: false,
            teacherPickerVisible: false,
            selectedTeacherLabel: '',
            submitting: false,
            addForm: {
                CampusId: 0,
                TeacherId: null,
                Name: '',
                Remark: ''
            },
            addRules: {
                CampusId: [{
                    validator(rule, value, callback) {
                        if (value === null || value === undefined || value === '') {
                            callback(new Error('请选择负责校区'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'change'
                }],
                TeacherId: [{ required: true, message: '请选择教职工', trigger: 'change' }]
            },

            // 编辑弹窗
            editDialogVisible: false,
            editForm: {
                Id: 0,
                Name: '',
                CampusId: 0,
                Remark: '',
                Enabled: true
            }
        };
    },
    computed: {
        hasSchoolSelected() {
            return !!normalizeDeptId(this.schoolId);
        },
        /** 仅真正的校区节点，排除学校根回退项。创建于 2026-09-21 */
        realCampusOptions() {
            return (this.campusOptions || []).filter(item => {
                const orgType = String(item.DeptOrgType || item.deptOrgType || '').toLowerCase();
                if (orgType === 'campus') return true;
                // 无类型标注时：排除与学校同 Id 的回退项
                return !deptIdsEqual(item.Id, this.schoolId) && orgType !== 'school' && orgType !== 'affiliateschool';
            });
        }
    },
    methods: {
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            return normalizeDeptId(this.schoolId);
        },

        treeNodeClick(data) {
            this.schoolId = treeNodeDeptId(data);
            this.schoolName = data.label || '';
            this.filterForm.campusId = null;
            this.loadCampusOptions();
            this.page = 1;
            this.loadTableData();
        },

        async loadCampusOptions() {
            if (!this.schoolId) return;
            try {
                const res = await getCampusList({ page: 1, intPageSize: 999, departmentId: this.schoolId });
                if (res.data && res.data.success) {
                    this.campusOptions = res.data.response.data || [];
                }
            } catch (err) {
                this.$message.error('加载校区列表失败');
            }
        },

        async loadTableData() {
            if (!this.schoolId) return;
            this.loading = true;
            try {
                const params = {
                    page: this.page,
                    intPageSize: this.pageSize,
                    schoolId: this.schoolId,
                    campusId: this.filterForm.campusId || 0,
                    name: this.filterForm.name || ''
                };
                const res = await getPsychologyTeacherListPage(params);
                if (res.data && res.data.success) {
                    const resp = res.data.response;
                    this.tableData = resp.data || [];
                    this.total = resp.dataCount || 0;
                } else {
                    this.tableData = [];
                    this.total = 0;
                }
            } catch (err) {
                this.$message.error('加载心理老师列表失败');
            } finally {
                this.loading = false;
            }
        },

        handleSearch() {
            this.page = 1;
            this.loadTableData();
        },

        handleReset() {
            this.filterForm.campusId = null;
            this.filterForm.name = '';
            this.page = 1;
            this.loadTableData();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.page = 1;
            this.loadTableData();
        },

        handlePageChange(val) {
            this.page = val;
            this.loadTableData();
        },

        handleToggleEnable(row) {
            const isEnable = row.Enabled;
            const teacherName = row.TeacherName || row.Name || '该教师';
            const actionText = isEnable ? '启用' : '停用';
            const tipText = isEnable
                ? `确认启用心理老师【${teacherName}】吗？启用后该教师在手机端将拥有心理咨询审核与核验签到权限。`
                : `确认停用心理老师【${teacherName}】吗？停用后该教师在手机端将无法进行心理咨询审核与签到。`;

            this.$confirm(tipText, `${actionText}确认`, {
                type: isEnable ? 'info' : 'warning',
                confirmButtonText: `确定${actionText}`,
                cancelButtonText: '取消',
                closeOnClickModal: false
            }).then(async () => {
                try {
                    const res = await togglePsychologyTeacherEnable({ id: row.Id, enabled: isEnable });
                    if (res.data && res.data.success) {
                        this.$message.success(`已${actionText}心理老师权限`);
                    } else {
                        row.Enabled = !isEnable;
                        this.$message.error(res.data ? res.data.msg : `${actionText}失败`);
                    }
                } catch (err) {
                    row.Enabled = !isEnable;
                    this.$message.error('网络异常，修改失败');
                }
            }).catch(() => {
                // 用户点击取消或关闭确认框，恢复 switch 原始状态
                row.Enabled = !isEnable;
            });
        },

        openAddDialog() {
            this.addForm = {
                CampusId: this.normalizeCampusIdForForm(normalizeDeptId(this.filterForm.campusId) || 0),
                TeacherId: null,
                Name: '',
                Remark: ''
            };
            this.selectedTeacherLabel = '';
            this.addDialogVisible = true;
            this.$nextTick(() => this.$refs.addForm && this.$refs.addForm.clearValidate());
        },

        /** 打开内部通讯录选教职工。创建于 2026-11-04 */
        openTeacherPicker() {
            if (!normalizeDeptId(this.schoolId)) {
                this.$message.warning('请先选择学校');
                return;
            }
            this.teacherPickerVisible = true;
        },

        clearSelectedTeacher() {
            this.addForm.TeacherId = null;
            this.addForm.Name = '';
            this.selectedTeacherLabel = '';
            this.$nextTick(() => {
                if (this.$refs.addForm) this.$refs.addForm.validateField('TeacherId');
            });
        },

        onTeacherPicked(person) {
            if (!person) return;
            this.addForm.TeacherId = person.id;
            this.addForm.Name = person.name || '';
            this.selectedTeacherLabel = person.name || '';
            this.$nextTick(() => {
                if (this.$refs.addForm) this.$refs.addForm.validateField('TeacherId');
            });
        },

        submitAddForm() {
            this.$refs.addForm.validate(async (valid) => {
                if (!valid) return;
                this.submitting = true;
                try {
                    const payload = {
                        SchoolId: this.schoolId,
                        CampusId: this.normalizeCampusIdForForm(this.addForm.CampusId),
                        TeacherId: this.addForm.TeacherId,
                        Name: this.addForm.Name,
                        Remark: this.addForm.Remark,
                        Enabled: true
                    };
                    const res = await addPsychologyTeacher(payload);
                    if (res.data && res.data.success) {
                        this.$message.success('新增心理老师成功');
                        this.addDialogVisible = false;
                        this.loadTableData();
                    } else {
                        this.$message.error(res.data ? res.data.msg : '新增失败');
                    }
                } catch (err) {
                    this.$message.error('新增异常，请重试');
                } finally {
                    this.submitting = false;
                }
            });
        },

        /** 是否「全部校区」（兼容接口返回数字 0 / 字符串 "0"）。创建于 2026-11-04 */
        isAllCampus(campusId) {
            return campusId === null || campusId === undefined || campusId === '' || campusId === 0 || campusId === '0';
        },

        /** 编辑态校区值：全部校区统一为数字 0，与 el-option :value="0" 对齐。创建于 2026-11-04 */
        normalizeCampusIdForForm(campusId) {
            if (this.isAllCampus(campusId)) return 0;
            return campusId;
        },

        openEditDialog(row) {
            this.editForm = {
                Id: row.Id,
                Name: row.TeacherName || row.Name || '',
                CampusId: this.normalizeCampusIdForForm(row.CampusId),
                Remark: row.Remark || '',
                Enabled: !!row.Enabled
            };
            this.editDialogVisible = true;
        },

        async submitEditForm() {
            this.submitting = true;
            try {
                const res = await updatePsychologyTeacher({
                    Id: this.editForm.Id,
                    CampusId: this.normalizeCampusIdForForm(this.editForm.CampusId),
                    Remark: this.editForm.Remark,
                    Enabled: this.editForm.Enabled
                });
                if (res.data && res.data.success) {
                    this.$message.success('修改成功');
                    this.editDialogVisible = false;
                    this.loadTableData();
                } else {
                    this.$message.error(res.data ? res.data.msg : '保存失败');
                }
            } catch (err) {
                this.$message.error('修改失败');
            } finally {
                this.submitting = false;
            }
        },

        handleDelete(row) {
            this.$confirm(`确认移除心理老师【${row.TeacherName || row.Name}】吗？移除后该账号将不再具备心理老师权限。`, '移除确认', {
                type: 'warning'
            }).then(async () => {
                const res = await deletePsychologyTeacher({ id: row.Id });
                if (res.data && res.data.success) {
                    this.$message.success('已移除心理老师');
                    this.loadTableData();
                } else {
                    this.$message.error(res.data ? res.data.msg : '移除失败');
                }
            }).catch(() => {});
        }
    },
    mounted() {
        const defaultSchoolId = this.resolveSchoolId();
        if (defaultSchoolId) {
            this.schoolId = defaultSchoolId;
            this.loadCampusOptions();
            this.loadTableData();
        }
    }
};
</script>

<style scoped>
.filter-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 8px;
    flex-shrink: 0;
}

.filter-form .el-form-item {
    margin-bottom: 6px;
}

.tip-bar {
    background: #f4f4f5;
    color: #606266;
    font-size: 13px;
    padding: 8px 12px;
    border-radius: 4px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.tip-bar i {
    color: #409EFF;
    font-size: 15px;
    margin-right: 8px;
}

.teacher-name {
    font-weight: 600;
    color: #303133;
}

.toolbar {
    margin-top: 8px;
    padding: 0;
    flex-shrink: 0;
}

.sub-hint {
    font-size: 12px;
    color: #909399;
    display: block;
    line-height: 1.4;
    margin-top: 4px;
}

.muted-text {
    color: #94a3b8;
}

.ps-pick-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: #475569;
    font-size: 13px;
}

.no-department-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 200px;
    color: #909399;
}

.no-department-tip i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #c0c4cc;
}
</style>
